import React from 'react';
import { getBrisbaneNow } from '../utils/eventDisplayUtils';

const EventAvailabilityBar = ({ row }) => {
  let eventStart = null;
  if (row.startDate && row.time) {
    const [startTime] = row.time.split(' - ');
    const [hour, minuteRaw] = startTime.split(':');
    let minute = 0;
    let hourNum = parseInt(hour, 10);
    let ampm = startTime.toLowerCase().includes('pm') ? 'pm' : 'am';
    if (minuteRaw) {
      const [min, rest] = minuteRaw.split(' ');
      minute = parseInt(min, 10);
      if (rest && rest.toLowerCase() === 'pm' && hourNum < 12) hourNum += 12;
      if (rest && rest.toLowerCase() === 'am' && hourNum === 12) hourNum = 0;
    }
    if (!minuteRaw && ampm === 'pm' && hourNum < 12) hourNum += 12;
    if (!minuteRaw && ampm === 'am' && hourNum === 12) hourNum = 0;
    const eventStartIso = `${row.startDate}T${hourNum.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:00+10:00`;
    eventStart = new Date(eventStartIso);
  }
  const now = getBrisbaneNow();

  let status = 'OPEN';
  const maxIsFinite = row.maxAttendees !== '∞' && row.maxAttendees !== 'unlimited';
  if (eventStart && now >= eventStart) {
    status = 'STARTED';
  } else if (
    (maxIsFinite && Number(row.registeredAttendees) >= Number(row.maxAttendees))
  ) {
    status = 'FULL';
  } else if (row.waitlistUserCount > 0) {
    status = 'FULL';
  }

  const statusBgStyles = {
    OPEN: 'bg-blue-200 bg-opacity-50', // Increased opacity
    FULL: 'bg-purple-200 bg-opacity-50', // Increased opacity
    STARTED: 'bg-yellow-200 bg-opacity-60', // Increased opacity
  };
  const statusTextStyles = {
    OPEN: 'text-blue-900',
    FULL: 'text-purple-900',
    STARTED: 'text-yellow-900 font-semibold',
  };

  const x = row.registeredAttendees;
  const y = (row.maxAttendees === '∞' || row.maxAttendees === 'unlimited')
    ? <span title="Unlimited" className="text-xs items-center">&infin;</span> // Adjusted to text-xs for consistent height
    : row.maxAttendees;
  const z = row.waitlistUserCount > 0 ? ` (+${row.waitlistUserCount} waitlist)` : '';

  return (
    <div
      className={`w-full px-2 py-1 rounded ${statusBgStyles[status]}`}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap', // Allow wrapping to prevent overflow
      }}
    >
      <div className="flex-1 min-w-0"> {/* Ensure text truncates if necessary */}
        <div className="flex items-center space-x-2 leading-tight"> {/* Adjusted leading-tight for consistent height */}
          <span className={`text-xs font-bold uppercase tracking-wide ${statusTextStyles[status]} flex-shrink-0`}>
            {status}
          </span>
          <div className="flex items-center text-xs text-gray-700 flex-shrink-0">
            <span>{x} of</span>
            <span className="ml-1 align-middle">{y}</span> {/* Ensured vertical alignment */}
            <span className="ml-1">attending{z}</span>
          </div>
        </div>
        <div className="text-xs text-gray-700 mt-1 truncate">
          <span className="font-bold">{row.time.split(' - ')[0]}</span>
          {row.duration && <span className="mx-1">•</span>}
          {row.duration && <span>{row.duration}</span>}
          <span className="mx-1">•</span>
          <span>{row.venue}</span>
        </div>
      </div>
      <a
        href={row.url}
        target="_blank"
        rel="noopener noreferrer"
        title="Open Event"
        className="inline-flex items-center border border-blue-200 hover:border-blue-300 rounded p-1 ml-2"
        style={{
          height: '2.5rem',
          justifyContent: 'center',
          alignItems: 'center', // Center vertically
          flexShrink: 0, // Prevent shrinking
        }}
      >
        <img
          src="https://opensports.net/apple-touch-icon.png"
          alt="OpenSports"
          className="w-6 h-6"
        />
      </a>
    </div>
  );
};

export default EventAvailabilityBar;
